import * as React from 'react';
import { IconSoundOff16, TDeviceType, UIHeading4 } from '@cian/ui-kit';
import cn from 'clsx';
import { useEffect, useRef } from 'react';

import { HOW_IT_WORKS_PREVIEW } from '../../constants/images';
import { HOW_IT_WORKS_VIDEO_URL } from '../../constants/videos';

import * as styles from './styles.css';

interface IHowItWorksVideoProps {
  onClick: () => void;
  width?: string;
  needStopVideo: boolean;
  deviceType: TDeviceType;
}

export const HowItWorksVideo: React.FC<IHowItWorksVideoProps> = ({
  onClick,
  width = '100%',
  deviceType,
  needStopVideo,
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (needStopVideo) {
      videoRef.current?.pause();

      return;
    }

    videoRef.current?.play();
  }, [needStopVideo]);

  return (
    <div className={cn(styles['container'], styles[deviceType])} onClick={onClick} data-testid="about-deal-block">
      <a className={styles['sound']}>
        <IconSoundOff16 color="white_100" />
        <UIHeading4 color="white_100">Смотреть со звуком</UIHeading4>
      </a>
      <video
        ref={videoRef}
        autoPlay
        muted
        playsInline
        loop
        width={width}
        preload="metadata"
        controls={false}
        poster={HOW_IT_WORKS_PREVIEW}
        className={cn(styles['video'], styles[deviceType])}
      >
        <source src={HOW_IT_WORKS_VIDEO_URL} type="video/mp4"></source>
      </video>
    </div>
  );
};
